import { useMemoizedFn } from 'ahooks';
import { useEffect, useRef } from 'react';
// biome-ignore lint/suspicious/noExplicitAny: PDF.js pdfDoc
export function usePdfCache(pdfDoc: any) {
    // biome-ignore lint/suspicious/noExplicitAny: 111
    const pageCacheRef = useRef<Map<number, any>>(new Map());
    // biome-ignore lint/suspicious/noExplicitAny: 111
    const textContentCacheRef = useRef<Map<number, any>>(new Map());
    // biome-ignore lint/suspicious/noExplicitAny: PDF.js pdfDoc
    const cachedPdfDocRef = useRef<any | null>(null);

    useEffect(() => {
        if (pdfDoc !== cachedPdfDocRef.current) {
            // 切换文档前显式调用 page.cleanup()，释放 PDF.js 内部的解码缓存
            for (const page of Array.from(pageCacheRef.current.values())) {
                try {
                    page?.cleanup?.();
                } catch {
                    // ignore
                }
            }
            pageCacheRef.current.clear();
            textContentCacheRef.current.clear();
            cachedPdfDocRef.current = pdfDoc;
        }
    }, [pdfDoc]);

    const getCachedPage = useMemoizedFn(async (pageNum: number) => {
        if (!pdfDoc) return null;
        if (pageCacheRef.current.has(pageNum)) {
            return pageCacheRef.current.get(pageNum);
        }
        const page = await pdfDoc.getPage(pageNum);
        pageCacheRef.current.set(pageNum, page);
        return page;
    });

    const getCachedTextContent = useMemoizedFn(async (pageNum: number) => {
        if (!pdfDoc) return null;
        if (textContentCacheRef.current.has(pageNum)) {
            return textContentCacheRef.current.get(pageNum);
        }
        const page = await getCachedPage(pageNum);
        if (!page) return null;
        const textContent = await page.getTextContent();
        textContentCacheRef.current.set(pageNum, textContent);
        return textContent;
    });

    return { getCachedPage, getCachedTextContent };
}
